/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConcernedSubjectCreateDto } from './concernedSubjectCreateDto.model';
import { ToDtsrcParDto } from './toDtsrcParDto.model';
import { ToDtsrcSubjectKnCreateDto } from './toDtsrcSubjectKnCreateDto.model';
import { CreateToDtsrcLvDto } from './createToDtsrcLvDto.model';
import { ProjectRequestDto } from './projectRequestDto.model';
import { ToDtsrcSubjectLpisCreateDto } from './toDtsrcSubjectLpisCreateDto.model';
import { CreateToDtsrcAreaDto } from './createToDtsrcAreaDto.model';


export interface CreateSchemaDto { 
    areaList?: Array<CreateToDtsrcAreaDto>;
    concernedSubjectList: Array<ConcernedSubjectCreateDto>;
    downloadOwnershipOverview?: boolean;
    downloadOwnershipOverviewTo?: string;
    lvList?: Array<CreateToDtsrcLvDto>;
    parList?: Array<ToDtsrcParDto>;
    project: ProjectRequestDto;
    subjectKnList?: Array<ToDtsrcSubjectKnCreateDto>;
    subjectLpisList?: Array<ToDtsrcSubjectLpisCreateDto>;
}

